import { transformHelium10Domain } from "@helium10/re-core";

export const mrsDomain = transformHelium10Domain(process.env.REACT_APP_MRS_BACKEND ?? "");

export const refundGenieApiLink = transformHelium10Domain(
  process.env.REACT_APP_REFUND_GENIE_BACKEND ?? "",
);

export const profileMarketPlacesLink = mrsDomain + "/v1/seller";
export const sellerV2Link = mrsDomain + "/v2/seller";

export const claimCasesListLink = mrsDomain + "/v1/claim-cases";
export const claimCasesExportLink = mrsDomain + "/v1/claim-cases/export";

export const packingListStatusLink = mrsDomain + "/v1/packingListStatus";

export const packingListPreviewLink = mrsDomain + "/v1/packing-list/preview";

export const packingListInfoLink = mrsDomain + "/v1/getPackingList";

export const packingListUploadFileLink = mrsDomain + "/v1/uploadPackingListFile";

export const packingListUploadDataLink = mrsDomain + "/v1/confirmUploadData";

export const ServiceRecordLink = {
  list: mrsDomain + "/v1/inbound/service-record/list",
  pageDownload: mrsDomain + "/v1/inbound/service-record/page/download",
  caseDetail: mrsDomain + "/v1/inbound/service-record/caseDetail",
  noteList: mrsDomain + "/v1/inbound/service-record/noteList",
  note: mrsDomain + "/v1/inbound/service-record/note",
  confirm: mrsDomain + "/v1/inbound/service-record/confirm",
  stop: mrsDomain + "/v1/inbound/service-record/stop",
  currentFiles: mrsDomain + "/v1/inbound/service-record/currentFiles",
};

export const InboundLink = {
  TableList: mrsDomain + "/v1/inbound-case/list",
  inboundCaseLink: mrsDomain + "/v1/inbound-case/link",
  annexDownload: mrsDomain + "/v1/inbound-case/annex/download",
  removeInbound: mrsDomain + "/v1/inbound-case/remove",
  uploadFileLink: mrsDomain + "/v1/inbound-case/proof/upload",
  shipmentSyncLink: mrsDomain + "/v1/inbound/shipment-sync",
  uploadSingle: mrsDomain + "/v1/document-center/upload/single",
  uploadBatch: mrsDomain + "/v1/document-center/upload/batch",
  uploadByContent: mrsDomain + "/v1/document-center/upload/byContent",
  confirmManage: mrsDomain + "/v1/inbound-case/manage/confirm",
  callbackResult: mrsDomain + "/v1/document-center/callbackResult",
  callbackS3Uploaded: mrsDomain + "/v1/document-center/callback/s3Uploaded",
};

export const OverViewLink = {
  TableList: mrsDomain + "/v1/claim-dashboard",
  TotalAcount: mrsDomain + "/v1/claim-dashboard/total",
};

export const fullServiceRemindLink = mrsDomain + "/v1/full-service/remind";
export const fullServiceEnableLink = mrsDomain + "/v1/full-service/enable-all";
export const mrsBoardingInfoLink = mrsDomain + "/v1/onboarding/info";
export const mrsSendInvitationLink = mrsDomain + "/v1/onboarding/sendInvitation";
export const mrsCheckPermissionLink = mrsDomain + "/v1/onboarding/checkPermission";
export const mrsStopReminders = mrsDomain + "/v1/reminder/ignore";
export const mrsReminderPlanChange = mrsDomain + "/v1/reminder/plan-change";
export const mrsReminderPlanChangeIgnore = mrsDomain + "/v1/reminder/plan-change/ignore";

export const acceptFeeTermsLink = mrsDomain + "/v1/billing-terms/acceptance";
export const landingPageSetupLink = mrsDomain + "/v1/landing-page/setup";

export const BillingLink = {
  tableList: mrsDomain + "/v1/billing/query",
  invoiceLink: mrsDomain + "/v1/billing/invoice-link",
  export: mrsDomain + "/v1/billing/export",
  exist: mrsDomain + "/v1/billing/exist",
};

export const packfeeLink = {
  firstEntry: mrsDomain + "/v1/fba-fee/first-use", // 每次进入页面调用一下这个接口,来判断是否要弹出蒙层和提示
  productList: mrsDomain + "/v1/fba-fee/all-product",
  productListExport: mrsDomain + "/v1/fba-fee/all-product/export", // 导出
  claimsList: mrsDomain + "/v1/fba-fee/pending-claim",
  downTemplate: mrsDomain + "/v1/fba-fee/all-product/download-template",
  uploadFile: mrsDomain + "/v1/fba-fee/all-product/upload-product-info",
  downFile: mrsDomain + "/v1/fba-fee/file-download",
  uploadHistoryList: mrsDomain + "/v1/fba-fee/all-product/upload-list",
  updatePackTypeLink: mrsDomain + "/v1/fba-fee/update-type", // 更新PackType
  updateRecordLink: mrsDomain + "/v1/fba-fee/update-record", // 更新尺寸
  claimDetailLink: mrsDomain + "/v1/fba-fee/get-detail", // 获取确认详情弹框
  claimConfirmLink: mrsDomain + "/v1/fba-fee/confirm", // 确认 claim
};

export const DocumentCenterLink = {
  uploadHistoryList: mrsDomain + "/v1/document-center/uploadHistory",
  uploadHistoryDetail: mrsDomain + "/v1/document-center/uploadHistory/detail",
  list: mrsDomain + "/v1/document-center/list",
  removeFile: mrsDomain + "/v1/document-center/removeFile",
  clearFile: mrsDomain + "/v1/document-center/clearFile",
  downloadFile: mrsDomain + "/v1/document-center/downloadFile",
  querySignatureUrl: mrsDomain + "/v1/document-center/querySignatureUrl",
};
